import { render } from "./GoodsCateSet.vue?vue&type=template&id=37c274ec&scoped=true&ts=true"
import script from "./GoodsCateSet.vue?vue&type=script&lang=ts"
export * from "./GoodsCateSet.vue?vue&type=script&lang=ts"

import "./GoodsCateSet.vue?vue&type=style&index=0&id=37c274ec&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c274ec"]])

export default __exports__